import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHONE_TEL, WA_URL } from "@/lib/constants";

export const StickyMobileBar = () => {
    const { t } = useLang();

    return (
        <div
            data-testid="sticky-mobile-bar"
            className="fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 gap-2.5 border-t border-white/10 bg-obsidian/92 p-3 backdrop-blur-xl md:hidden"
            style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        >
            <a
                href={PHONE_TEL}
                data-testid="sticky-call-btn"
                className="flex items-center justify-center gap-2 rounded-xl bg-volt py-3.5 text-sm font-extrabold text-obsidian active:scale-[0.98] shadow-[0_0_30px_rgba(212,255,0,0.35)]"
            >
                <Phone className="h-4 w-4" />
                {t("sticky.call")}
            </a>
            <a
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sticky-whatsapp-btn"
                className="flex items-center justify-center gap-2 rounded-xl bg-whatsapp py-3.5 text-sm font-extrabold text-obsidian active:scale-[0.98]"
            >
                <MessageCircle className="h-4 w-4" />
                {t("sticky.wa")}
            </a>
        </div>
    );
};

export default StickyMobileBar;
